/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfDevice } from '../models';
// @ts-ignore
import type { BfEmailNewRecipient } from '../models';
// @ts-ignore
import type { BfEmailRecipient } from '../models';
// @ts-ignore
import type { BfEventWebhook } from '../models';
// @ts-ignore
import type { BfMessageHistory } from '../models';
// @ts-ignore
import type { BfNotificationRequest } from '../models';
// @ts-ignore
import type { BfNotificationState } from '../models';
// @ts-ignore
import type { BfNotificationTrace } from '../models';
// @ts-ignore
import type { BfRegisterDevice } from '../models';
// @ts-ignore
import type { BfSmsNewRecipient } from '../models';
// @ts-ignore
import type { BfSmsRecipient } from '../models';
// @ts-ignore
import type { BfWebhook } from '../models';
/**
 * NotificationApi - axios parameter creator
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new notification for the user
         * @summary Create notification subscription
         * @param {BfNotificationRequest} bfNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification: async (bfNotificationRequest: BfNotificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfNotificationRequest' is not null or undefined
            assertParamExists('createNotification', 'bfNotificationRequest', bfNotificationRequest)
            const localVarPath = `/v1/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new webhook. The payload delivered will contain a `BfEventWebhook` object. You can inspect it in the 418 response.
         * @summary Create webhook
         * @param {BfWebhook} bfWebhook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebhook: async (bfWebhook: BfWebhook, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfWebhook' is not null or undefined
            assertParamExists('createWebhook', 'bfWebhook', bfWebhook)
            const localVarPath = `/v1/notifications/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfWebhook, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a recipient from the user\'s list of validated email addresss
         * @summary Delete email recipient
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailRecipient: async (recipientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('deleteEmailRecipient', 'recipientId', recipientId)
            const localVarPath = `/v1/notifications/validate/email/{recipient_id}`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a particular notification by its notification_id
         * @summary Delete notification by ID
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('deleteNotification', 'notificationId', notificationId)
            const localVarPath = `/v1/notifications/{notification_id}`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a recipient from the user\'s list of validated SMS numbers
         * @summary Delete SMS recipient
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSmsRecipient: async (recipientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('deleteSmsRecipient', 'recipientId', recipientId)
            const localVarPath = `/v1/notifications/validate/sms/{recipient_id}`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a test FCM push message to the user
         * @summary Send test FCM
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceFcmTest: async (deviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('deviceFcmTest', 'deviceId', deviceId)
            const localVarPath = `/v1/notifications/devices/{device_id}/test`
                .replace(`{${"device_id"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns devices registered by the user
         * @summary Register a device
         * @param {BfRegisterDevice} bfRegisterDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceRegister: async (bfRegisterDevice: BfRegisterDevice, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfRegisterDevice' is not null or undefined
            assertParamExists('deviceRegister', 'bfRegisterDevice', bfRegisterDevice)
            const localVarPath = `/v1/notifications/devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfRegisterDevice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns device registered by ID
         * @summary Get device by ID
         * @param {string} deviceId ID of registered device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice: async (deviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getDevice', 'deviceId', deviceId)
            const localVarPath = `/v1/notifications/devices/{device_id}`
                .replace(`{${"device_id"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns device registered by ID
         * @summary Get device FCM token
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceFcmToken: async (deviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getDeviceFcmToken', 'deviceId', deviceId)
            const localVarPath = `/v1/notifications/devices/{device_id}/fcm`
                .replace(`{${"device_id"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns devices registered by the user
         * @summary List registered devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/notifications/devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a validated email address
         * @summary Get email address by ID
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailValidation: async (recipientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('getEmailValidation', 'recipientId', recipientId)
            const localVarPath = `/v1/notifications/validate/email/{recipient_id}`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a particular notification by its notification_id
         * @summary Get notification by ID
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('getNotification', 'notificationId', notificationId)
            const localVarPath = `/v1/notifications/{notification_id}`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reconstructs notification behaviour for an event by eKey: messages recorded per stored version, and per-subscription match outcomes when tracing a specific user. Tracing another user requires the NotificationTrace policy or delegate access; omitting `userId` returns sends across all users and requires the NotificationTrace policy.
         * @summary Notification trace for an event
         * @param {string} eKey Event key
         * @param {string} [userId] Trace this user\&#39;s subscriptions (self, NotificationTrace policy, or delegate access); omit for all users (NotificationTrace policy required)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationEventTrace: async (eKey: string, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eKey' is not null or undefined
            assertParamExists('getNotificationEventTrace', 'eKey', eKey)
            const localVarPath = `/v1/notifications/event/{e_key}`
                .replace(`{${"e_key"}}`, encodeURIComponent(String(eKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns notifications which have recently been sent to the user
         * @summary Get notification history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationHistory: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/notifications/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List notifications and registered endpoints for the user
         * @summary Notification state for user
         * @param {string} [userId] User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationState: async (userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/notifications/state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a validated SMS number
         * @summary Get SMS number by ID
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmsValidation: async (recipientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('getSmsValidation', 'recipientId', recipientId)
            const localVarPath = `/v1/notifications/validate/sms/{recipient_id}`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a webhook definition by ID
         * @summary Get webhook by ID
         * @param {string} webhookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhook: async (webhookId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('getWebhook', 'webhookId', webhookId)
            const localVarPath = `/v1/notifications/webhook/{webhook_id}`
                .replace(`{${"webhook_id"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns device registered by ID
         * @summary List webhooks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhooks: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/notifications/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin email validation of an email address, allowing it to receive notifications
         * @summary Initiate email validation
         * @param {BfEmailNewRecipient} bfEmailNewRecipient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateEmailValidation: async (bfEmailNewRecipient: BfEmailNewRecipient, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfEmailNewRecipient' is not null or undefined
            assertParamExists('initiateEmailValidation', 'bfEmailNewRecipient', bfEmailNewRecipient)
            const localVarPath = `/v1/notifications/validate/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfEmailNewRecipient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin SMS validation of a phone number, allowing it to receive notifications
         * @summary Initiate SMS validation
         * @param {BfSmsNewRecipient} bfSmsNewRecipient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateSmsValidation: async (bfSmsNewRecipient: BfSmsNewRecipient, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfSmsNewRecipient' is not null or undefined
            assertParamExists('initiateSmsValidation', 'bfSmsNewRecipient', bfSmsNewRecipient)
            const localVarPath = `/v1/notifications/validate/sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfSmsNewRecipient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns email addresses which have been successfully validated
         * @summary List email addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmailValidation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/notifications/validate/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns phone numbers which have been successfully validated
         * @summary List SMS numbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSmsValidation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/notifications/validate/sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the notifications for the current user
         * @summary List notification subscriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the device if successful
         * @summary Delete device by ID
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDevice: async (deviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('removeDevice', 'deviceId', deviceId)
            const localVarPath = `/v1/notifications/devices/{device_id}`
                .replace(`{${"device_id"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a webhook definition by ID
         * @summary Delete webhook by ID
         * @param {string} webhookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWebhook: async (webhookId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('removeWebhook', 'webhookId', webhookId)
            const localVarPath = `/v1/notifications/webhook/{webhook_id}`
                .replace(`{${"webhook_id"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a test SMS message to the user
         * @summary Send test SMS
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSmsRecipient: async (recipientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('testSmsRecipient', 'recipientId', recipientId)
            const localVarPath = `/v1/notifications/sms/{recipient_id}/test`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns nothing on success
         * @summary Update device token
         * @param {string} deviceId ID of registered device
         * @param {BfRegisterDevice} bfRegisterDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceToken: async (deviceId: string, bfRegisterDevice: BfRegisterDevice, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('updateDeviceToken', 'deviceId', deviceId)
            // verify required parameter 'bfRegisterDevice' is not null or undefined
            assertParamExists('updateDeviceToken', 'bfRegisterDevice', bfRegisterDevice)
            const localVarPath = `/v1/notifications/devices/{device_id}`
                .replace(`{${"device_id"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfRegisterDevice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing notification for the user
         * @summary Update notification by ID
         * @param {string} notificationId 
         * @param {BfNotificationRequest} bfNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotification: async (notificationId: string, bfNotificationRequest: BfNotificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('updateNotification', 'notificationId', notificationId)
            // verify required parameter 'bfNotificationRequest' is not null or undefined
            assertParamExists('updateNotification', 'bfNotificationRequest', bfNotificationRequest)
            const localVarPath = `/v1/notifications/{notification_id}`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates a email address
         * @summary Validate email address
         * @param {string} recipientId 
         * @param {number} verificationCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmailAddress: async (recipientId: string, verificationCode: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('validateEmailAddress', 'recipientId', recipientId)
            // verify required parameter 'verificationCode' is not null or undefined
            assertParamExists('validateEmailAddress', 'verificationCode', verificationCode)
            const localVarPath = `/v1/notifications/validate/email/{recipient_id}/{verification_code}`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${"verification_code"}}`, encodeURIComponent(String(verificationCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates a SMS number
         * @summary Validate SMS number
         * @param {string} recipientIdAndCode 
         * @param {number} verificationCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSmsNumber: async (recipientIdAndCode: string, verificationCode: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientIdAndCode' is not null or undefined
            assertParamExists('validateSmsNumber', 'recipientIdAndCode', recipientIdAndCode)
            // verify required parameter 'verificationCode' is not null or undefined
            assertParamExists('validateSmsNumber', 'verificationCode', verificationCode)
            const localVarPath = `/v1/notifications/validate/sms/{recipient_id_and_code}/{verification_code}`
                .replace(`{${"recipient_id_and_code"}}`, encodeURIComponent(String(recipientIdAndCode)))
                .replace(`{${"verification_code"}}`, encodeURIComponent(String(verificationCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new notification for the user
         * @summary Create notification subscription
         * @param {BfNotificationRequest} bfNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotification(bfNotificationRequest: BfNotificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotification(bfNotificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.createNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new webhook. The payload delivered will contain a `BfEventWebhook` object. You can inspect it in the 418 response.
         * @summary Create webhook
         * @param {BfWebhook} bfWebhook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWebhook(bfWebhook: BfWebhook, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWebhook(bfWebhook, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.createWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a recipient from the user\'s list of validated email addresss
         * @summary Delete email recipient
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmailRecipient(recipientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfEmailRecipient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmailRecipient(recipientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.deleteEmailRecipient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a particular notification by its notification_id
         * @summary Delete notification by ID
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNotification(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfNotificationRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNotification(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.deleteNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a recipient from the user\'s list of validated SMS numbers
         * @summary Delete SMS recipient
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSmsRecipient(recipientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfSmsRecipient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSmsRecipient(recipientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.deleteSmsRecipient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a test FCM push message to the user
         * @summary Send test FCM
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceFcmTest(deviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceFcmTest(deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.deviceFcmTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns devices registered by the user
         * @summary Register a device
         * @param {BfRegisterDevice} bfRegisterDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceRegister(bfRegisterDevice: BfRegisterDevice, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceRegister(bfRegisterDevice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.deviceRegister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns device registered by ID
         * @summary Get device by ID
         * @param {string} deviceId ID of registered device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevice(deviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfDevice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevice(deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns device registered by ID
         * @summary Get device FCM token
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceFcmToken(deviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceFcmToken(deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getDeviceFcmToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns devices registered by the user
         * @summary List registered devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfDevice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a validated email address
         * @summary Get email address by ID
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailValidation(recipientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfEmailRecipient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailValidation(recipientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getEmailValidation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a particular notification by its notification_id
         * @summary Get notification by ID
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotification(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfNotificationRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotification(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reconstructs notification behaviour for an event by eKey: messages recorded per stored version, and per-subscription match outcomes when tracing a specific user. Tracing another user requires the NotificationTrace policy or delegate access; omitting `userId` returns sends across all users and requires the NotificationTrace policy.
         * @summary Notification trace for an event
         * @param {string} eKey Event key
         * @param {string} [userId] Trace this user\&#39;s subscriptions (self, NotificationTrace policy, or delegate access); omit for all users (NotificationTrace policy required)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationEventTrace(eKey: string, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfNotificationTrace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationEventTrace(eKey, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getNotificationEventTrace']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns notifications which have recently been sent to the user
         * @summary Get notification history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationHistory(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfMessageHistory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationHistory(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getNotificationHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List notifications and registered endpoints for the user
         * @summary Notification state for user
         * @param {string} [userId] User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationState(userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfNotificationState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationState(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getNotificationState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a validated SMS number
         * @summary Get SMS number by ID
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSmsValidation(recipientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfSmsRecipient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSmsValidation(recipientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getSmsValidation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a webhook definition by ID
         * @summary Get webhook by ID
         * @param {string} webhookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhook(webhookId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfWebhook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhook(webhookId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns device registered by ID
         * @summary List webhooks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhooks(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfWebhook>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhooks(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getWebhooks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin email validation of an email address, allowing it to receive notifications
         * @summary Initiate email validation
         * @param {BfEmailNewRecipient} bfEmailNewRecipient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateEmailValidation(bfEmailNewRecipient: BfEmailNewRecipient, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfEmailRecipient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateEmailValidation(bfEmailNewRecipient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.initiateEmailValidation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin SMS validation of a phone number, allowing it to receive notifications
         * @summary Initiate SMS validation
         * @param {BfSmsNewRecipient} bfSmsNewRecipient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateSmsValidation(bfSmsNewRecipient: BfSmsNewRecipient, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfSmsRecipient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateSmsValidation(bfSmsNewRecipient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.initiateSmsValidation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns email addresses which have been successfully validated
         * @summary List email addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEmailValidation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfEmailRecipient>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEmailValidation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.listEmailValidation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns phone numbers which have been successfully validated
         * @summary List SMS numbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSmsValidation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfSmsRecipient>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSmsValidation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.listSmsValidation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the notifications for the current user
         * @summary List notification subscriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfNotificationRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.notifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the device if successful
         * @summary Delete device by ID
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDevice(deviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDevice(deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.removeDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a webhook definition by ID
         * @summary Delete webhook by ID
         * @param {string} webhookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeWebhook(webhookId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeWebhook(webhookId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.removeWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a test SMS message to the user
         * @summary Send test SMS
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testSmsRecipient(recipientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testSmsRecipient(recipientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.testSmsRecipient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns nothing on success
         * @summary Update device token
         * @param {string} deviceId ID of registered device
         * @param {BfRegisterDevice} bfRegisterDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDeviceToken(deviceId: string, bfRegisterDevice: BfRegisterDevice, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDeviceToken(deviceId, bfRegisterDevice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.updateDeviceToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing notification for the user
         * @summary Update notification by ID
         * @param {string} notificationId 
         * @param {BfNotificationRequest} bfNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotification(notificationId: string, bfNotificationRequest: BfNotificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotification(notificationId, bfNotificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.updateNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates a email address
         * @summary Validate email address
         * @param {string} recipientId 
         * @param {number} verificationCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateEmailAddress(recipientId: string, verificationCode: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfEmailRecipient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateEmailAddress(recipientId, verificationCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.validateEmailAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates a SMS number
         * @summary Validate SMS number
         * @param {string} recipientIdAndCode 
         * @param {number} verificationCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateSmsNumber(recipientIdAndCode: string, verificationCode: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfSmsRecipient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateSmsNumber(recipientIdAndCode, verificationCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.validateSmsNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationApi - factory interface
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * Create a new notification for the user
         * @summary Create notification subscription
         * @param {BfNotificationRequest} bfNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(bfNotificationRequest: BfNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createNotification(bfNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new webhook. The payload delivered will contain a `BfEventWebhook` object. You can inspect it in the 418 response.
         * @summary Create webhook
         * @param {BfWebhook} bfWebhook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebhook(bfWebhook: BfWebhook, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createWebhook(bfWebhook, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a recipient from the user\'s list of validated email addresss
         * @summary Delete email recipient
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailRecipient(recipientId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfEmailRecipient> {
            return localVarFp.deleteEmailRecipient(recipientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a particular notification by its notification_id
         * @summary Delete notification by ID
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(notificationId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfNotificationRequest> {
            return localVarFp.deleteNotification(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a recipient from the user\'s list of validated SMS numbers
         * @summary Delete SMS recipient
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSmsRecipient(recipientId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfSmsRecipient> {
            return localVarFp.deleteSmsRecipient(recipientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a test FCM push message to the user
         * @summary Send test FCM
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceFcmTest(deviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deviceFcmTest(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns devices registered by the user
         * @summary Register a device
         * @param {BfRegisterDevice} bfRegisterDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceRegister(bfRegisterDevice: BfRegisterDevice, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deviceRegister(bfRegisterDevice, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns device registered by ID
         * @summary Get device by ID
         * @param {string} deviceId ID of registered device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice(deviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfDevice> {
            return localVarFp.getDevice(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns device registered by ID
         * @summary Get device FCM token
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceFcmToken(deviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getDeviceFcmToken(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns devices registered by the user
         * @summary List registered devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevices(options?: RawAxiosRequestConfig): AxiosPromise<Array<BfDevice>> {
            return localVarFp.getDevices(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a validated email address
         * @summary Get email address by ID
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailValidation(recipientId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfEmailRecipient> {
            return localVarFp.getEmailValidation(recipientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a particular notification by its notification_id
         * @summary Get notification by ID
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(notificationId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfNotificationRequest> {
            return localVarFp.getNotification(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Reconstructs notification behaviour for an event by eKey: messages recorded per stored version, and per-subscription match outcomes when tracing a specific user. Tracing another user requires the NotificationTrace policy or delegate access; omitting `userId` returns sends across all users and requires the NotificationTrace policy.
         * @summary Notification trace for an event
         * @param {string} eKey Event key
         * @param {string} [userId] Trace this user\&#39;s subscriptions (self, NotificationTrace policy, or delegate access); omit for all users (NotificationTrace policy required)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationEventTrace(eKey: string, userId?: string, options?: RawAxiosRequestConfig): AxiosPromise<BfNotificationTrace> {
            return localVarFp.getNotificationEventTrace(eKey, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns notifications which have recently been sent to the user
         * @summary Get notification history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationHistory(options?: RawAxiosRequestConfig): AxiosPromise<Array<BfMessageHistory>> {
            return localVarFp.getNotificationHistory(options).then((request) => request(axios, basePath));
        },
        /**
         * List notifications and registered endpoints for the user
         * @summary Notification state for user
         * @param {string} [userId] User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationState(userId?: string, options?: RawAxiosRequestConfig): AxiosPromise<BfNotificationState> {
            return localVarFp.getNotificationState(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a validated SMS number
         * @summary Get SMS number by ID
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmsValidation(recipientId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfSmsRecipient> {
            return localVarFp.getSmsValidation(recipientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a webhook definition by ID
         * @summary Get webhook by ID
         * @param {string} webhookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhook(webhookId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfWebhook> {
            return localVarFp.getWebhook(webhookId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns device registered by ID
         * @summary List webhooks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhooks(options?: RawAxiosRequestConfig): AxiosPromise<Array<BfWebhook>> {
            return localVarFp.getWebhooks(options).then((request) => request(axios, basePath));
        },
        /**
         * Begin email validation of an email address, allowing it to receive notifications
         * @summary Initiate email validation
         * @param {BfEmailNewRecipient} bfEmailNewRecipient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateEmailValidation(bfEmailNewRecipient: BfEmailNewRecipient, options?: RawAxiosRequestConfig): AxiosPromise<BfEmailRecipient> {
            return localVarFp.initiateEmailValidation(bfEmailNewRecipient, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin SMS validation of a phone number, allowing it to receive notifications
         * @summary Initiate SMS validation
         * @param {BfSmsNewRecipient} bfSmsNewRecipient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateSmsValidation(bfSmsNewRecipient: BfSmsNewRecipient, options?: RawAxiosRequestConfig): AxiosPromise<BfSmsRecipient> {
            return localVarFp.initiateSmsValidation(bfSmsNewRecipient, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns email addresses which have been successfully validated
         * @summary List email addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmailValidation(options?: RawAxiosRequestConfig): AxiosPromise<Array<BfEmailRecipient>> {
            return localVarFp.listEmailValidation(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns phone numbers which have been successfully validated
         * @summary List SMS numbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSmsValidation(options?: RawAxiosRequestConfig): AxiosPromise<Array<BfSmsRecipient>> {
            return localVarFp.listSmsValidation(options).then((request) => request(axios, basePath));
        },
        /**
         * List the notifications for the current user
         * @summary List notification subscriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifications(options?: RawAxiosRequestConfig): AxiosPromise<Array<BfNotificationRequest>> {
            return localVarFp.notifications(options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the device if successful
         * @summary Delete device by ID
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDevice(deviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeDevice(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a webhook definition by ID
         * @summary Delete webhook by ID
         * @param {string} webhookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWebhook(webhookId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeWebhook(webhookId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a test SMS message to the user
         * @summary Send test SMS
         * @param {string} recipientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSmsRecipient(recipientId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testSmsRecipient(recipientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns nothing on success
         * @summary Update device token
         * @param {string} deviceId ID of registered device
         * @param {BfRegisterDevice} bfRegisterDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceToken(deviceId: string, bfRegisterDevice: BfRegisterDevice, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDeviceToken(deviceId, bfRegisterDevice, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing notification for the user
         * @summary Update notification by ID
         * @param {string} notificationId 
         * @param {BfNotificationRequest} bfNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotification(notificationId: string, bfNotificationRequest: BfNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateNotification(notificationId, bfNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates a email address
         * @summary Validate email address
         * @param {string} recipientId 
         * @param {number} verificationCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmailAddress(recipientId: string, verificationCode: number, options?: RawAxiosRequestConfig): AxiosPromise<BfEmailRecipient> {
            return localVarFp.validateEmailAddress(recipientId, verificationCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates a SMS number
         * @summary Validate SMS number
         * @param {string} recipientIdAndCode 
         * @param {number} verificationCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSmsNumber(recipientIdAndCode: string, verificationCode: number, options?: RawAxiosRequestConfig): AxiosPromise<BfSmsRecipient> {
            return localVarFp.validateSmsNumber(recipientIdAndCode, verificationCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 */
export class NotificationApi extends BaseAPI {
    /**
     * Create a new notification for the user
     * @summary Create notification subscription
     * @param {BfNotificationRequest} bfNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createNotification(bfNotificationRequest: BfNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).createNotification(bfNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new webhook. The payload delivered will contain a `BfEventWebhook` object. You can inspect it in the 418 response.
     * @summary Create webhook
     * @param {BfWebhook} bfWebhook 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createWebhook(bfWebhook: BfWebhook, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).createWebhook(bfWebhook, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a recipient from the user\'s list of validated email addresss
     * @summary Delete email recipient
     * @param {string} recipientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteEmailRecipient(recipientId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).deleteEmailRecipient(recipientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a particular notification by its notification_id
     * @summary Delete notification by ID
     * @param {string} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteNotification(notificationId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).deleteNotification(notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a recipient from the user\'s list of validated SMS numbers
     * @summary Delete SMS recipient
     * @param {string} recipientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSmsRecipient(recipientId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).deleteSmsRecipient(recipientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a test FCM push message to the user
     * @summary Send test FCM
     * @param {string} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deviceFcmTest(deviceId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).deviceFcmTest(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns devices registered by the user
     * @summary Register a device
     * @param {BfRegisterDevice} bfRegisterDevice 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deviceRegister(bfRegisterDevice: BfRegisterDevice, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).deviceRegister(bfRegisterDevice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns device registered by ID
     * @summary Get device by ID
     * @param {string} deviceId ID of registered device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDevice(deviceId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getDevice(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns device registered by ID
     * @summary Get device FCM token
     * @param {string} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDeviceFcmToken(deviceId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getDeviceFcmToken(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns devices registered by the user
     * @summary List registered devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDevices(options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getDevices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a validated email address
     * @summary Get email address by ID
     * @param {string} recipientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmailValidation(recipientId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getEmailValidation(recipientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a particular notification by its notification_id
     * @summary Get notification by ID
     * @param {string} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotification(notificationId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getNotification(notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reconstructs notification behaviour for an event by eKey: messages recorded per stored version, and per-subscription match outcomes when tracing a specific user. Tracing another user requires the NotificationTrace policy or delegate access; omitting `userId` returns sends across all users and requires the NotificationTrace policy.
     * @summary Notification trace for an event
     * @param {string} eKey Event key
     * @param {string} [userId] Trace this user\&#39;s subscriptions (self, NotificationTrace policy, or delegate access); omit for all users (NotificationTrace policy required)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotificationEventTrace(eKey: string, userId?: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getNotificationEventTrace(eKey, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns notifications which have recently been sent to the user
     * @summary Get notification history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotificationHistory(options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getNotificationHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List notifications and registered endpoints for the user
     * @summary Notification state for user
     * @param {string} [userId] User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotificationState(userId?: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getNotificationState(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a validated SMS number
     * @summary Get SMS number by ID
     * @param {string} recipientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSmsValidation(recipientId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getSmsValidation(recipientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a webhook definition by ID
     * @summary Get webhook by ID
     * @param {string} webhookId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWebhook(webhookId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getWebhook(webhookId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns device registered by ID
     * @summary List webhooks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWebhooks(options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getWebhooks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin email validation of an email address, allowing it to receive notifications
     * @summary Initiate email validation
     * @param {BfEmailNewRecipient} bfEmailNewRecipient 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initiateEmailValidation(bfEmailNewRecipient: BfEmailNewRecipient, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).initiateEmailValidation(bfEmailNewRecipient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin SMS validation of a phone number, allowing it to receive notifications
     * @summary Initiate SMS validation
     * @param {BfSmsNewRecipient} bfSmsNewRecipient 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initiateSmsValidation(bfSmsNewRecipient: BfSmsNewRecipient, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).initiateSmsValidation(bfSmsNewRecipient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns email addresses which have been successfully validated
     * @summary List email addresses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listEmailValidation(options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).listEmailValidation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns phone numbers which have been successfully validated
     * @summary List SMS numbers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSmsValidation(options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).listSmsValidation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the notifications for the current user
     * @summary List notification subscriptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notifications(options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).notifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the device if successful
     * @summary Delete device by ID
     * @param {string} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeDevice(deviceId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).removeDevice(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a webhook definition by ID
     * @summary Delete webhook by ID
     * @param {string} webhookId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeWebhook(webhookId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).removeWebhook(webhookId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a test SMS message to the user
     * @summary Send test SMS
     * @param {string} recipientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public testSmsRecipient(recipientId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).testSmsRecipient(recipientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns nothing on success
     * @summary Update device token
     * @param {string} deviceId ID of registered device
     * @param {BfRegisterDevice} bfRegisterDevice 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDeviceToken(deviceId: string, bfRegisterDevice: BfRegisterDevice, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).updateDeviceToken(deviceId, bfRegisterDevice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing notification for the user
     * @summary Update notification by ID
     * @param {string} notificationId 
     * @param {BfNotificationRequest} bfNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateNotification(notificationId: string, bfNotificationRequest: BfNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).updateNotification(notificationId, bfNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates a email address
     * @summary Validate email address
     * @param {string} recipientId 
     * @param {number} verificationCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateEmailAddress(recipientId: string, verificationCode: number, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).validateEmailAddress(recipientId, verificationCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates a SMS number
     * @summary Validate SMS number
     * @param {string} recipientIdAndCode 
     * @param {number} verificationCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateSmsNumber(recipientIdAndCode: string, verificationCode: number, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).validateSmsNumber(recipientIdAndCode, verificationCode, options).then((request) => request(this.axios, this.basePath));
    }
}

